import ImageSelect from './ImageSelect';

export default ImageSelect;
